import { END_POINTS } from "../../constants/endpoints";
import { ignite_url } from "../../constants/variables";

export const getCustomConfig = async (requestOptions) => {
  const res = await fetch(
    ignite_url + END_POINTS.THIRD_PARTY_APIS.API_WORKFLOW_CONFIG,
    requestOptions
  )
    .then((res) => {
      if (!res.ok) {
        throw new Error(res.status);
      }
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return { status: err.message };
    });

  return res;
};
